export default {
		"submit": {
			"button": {
				"subtotal_display": "button",
				"caption": "Add to Cart",
				"target": "content20200609074252_795741"
			},
			"page": {
				"title": "Thank you",
				"url": "https://botsheets.com"
			}
		},
		"collections": [{
			"select_max": 5,
			"select_default": "0",
			"columns": [{
				"column_name": "Size",
				"join_type": "delimiter",
				"type": "string",
				"mc_field": "selected_size",
				"join_with": " "
			}, {
				"column_name": "Price",
				"join_type": "add",
				"type": "price",
				"mc_field": "item_price",
				"join_with": ","
			}],
			"display": {
				"title": {
					"padding": "3",
					"size": "4",
					"color": "blue",
					"align": "center"
				},
				"columns": {
					"padding": "3",
					"size": "4",
					"color": "blue",
					"align": "center"
				}
			},
			"select_type": "radio",
			"title": "Select a Size",
			"select_min": 0
		}, {
			"select_max": 999,
			"select_type": "radio",
			"title": "Select a Color",
			"select_default": "0",
			"select_min": 0,
			"columns": [{
				"column_name": "Color",
				"join_type": "delimiter",
				"type": "string",
				"mc_field": "selected_color",
				"join_with": " "
			}]
		}],
		"currency": "USD",
		"theme": {
			"color": {
				"main": "#0078FF"
			}
		},
		"type": "generic",
		"title": "Choose Options",
		"version": "2"
	}